var pug = require("!../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Ch3\u003EYou are not allowed to access this page\u003C\u002Fh3\u003E";;return pug_html;};
module.exports = template;